import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import React, { useEffect, useRef } from 'react';
import { LlmChunkItem } from '../../../types';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-thread.module.scss';

export type PageThreadProps = {
};

export const PageThread: React.FC<PageThreadProps> = () => {
  const ref = useRef<HTMLDivElement>(null);
  const label = useLabel();
  const {
    ChunkWrapper,
    Feedback,
    PageLoading,
    Stream,
  } = useLlm(state => state.components);
  const enableFeedback = useLlm(state => state.app?.contents.enableFeedback);
  const messages = useLlm(state => state.messages);
  const message = useLlm(state => state.message);
  const streaming = useLlm(state => state.streaming);
  const hasValidChunks = useLlm(state => (state.chunks || []).reduce<boolean>((p, c: LlmChunkItem) => {
    return p || !['header', 'log', 'info', 'end'].includes(c.type as string);
  }, false));
  useEffect(() => {
    window.scrollTo({ top: 0 });
    /*
    if (ref.current) {
      ref.current.scrollIntoView();
    }
    */
  }, [message, hasValidChunks]);

  const classNames = getClassNames(style.thread);

  // console.log('message', message);

  return (
    <section ref={ref} className={classNames}>
      {hasValidChunks ? (
        <Stream className={getClassNames(style.message, '-assistant')} index={messages.length} />
      ) : (
        streaming ? (
          <PageLoading />
        ) : (
          <>
            {message && (
              <div
                key={`llm-message-${message.messageId}-0`}
                className={getClassNames(style.message, `-${message.role}`)}
                role="region"
                aria-label={message.role === 'user' ? label('llm.question') : label('llm.answer')}>
                {message.chunks.map((chunk, c) => (
                  <ChunkWrapper
                    key={`llm-message-${message.messageId}-chunk-${c}`}
                    className={getClassNames(style.messageInner, `-${chunk.type}`)}
                    item={chunk} chunkIndex={c} index={0} total={messages.length} role={message.role}
                  />
                ))}
                {enableFeedback && (
                  <Feedback message={message} />
                )}
              </div>
            )}
          </>
        )
      )}
    </section>
  );
};
